var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("系统管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTab" },
          [
            _c(
              "el-form",
              {
                ref: "ruleForm",
                staticClass: "demo-ruleForm",
                attrs: {
                  model: _vm.ruleForm,
                  rules: _vm.rules,
                  "label-width": "100px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "平台名称", prop: "name" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入平台名称" },
                      model: {
                        value: _vm.ruleForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "name", $$v)
                        },
                        expression: "ruleForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "平台简称", prop: "referred" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入平台简称" },
                      model: {
                        value: _vm.ruleForm.referred,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "referred", $$v)
                        },
                        expression: "ruleForm.referred",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "公司地址", prop: "address" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入公司地址" },
                      model: {
                        value: _vm.ruleForm.address,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "address", $$v)
                        },
                        expression: "ruleForm.address",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "联系电话", prop: "tel" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入联系电话" },
                      model: {
                        value: _vm.ruleForm.tel,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "tel", $$v)
                        },
                        expression: "ruleForm.tel",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "Logo", prop: "logo" } },
                  [
                    _c(
                      "el-upload",
                      {
                        staticClass: "avatar-uploader",
                        attrs: {
                          action: _vm.uploadUrl,
                          headers: _vm.deader,
                          "show-file-list": false,
                          "on-success": _vm.handleAvatarSuccess,
                        },
                      },
                      [
                        _vm.ruleForm.logo
                          ? _c("img", {
                              staticClass: "avatar",
                              attrs: { src: _vm.ruleForm.logo },
                            })
                          : _c("i", {
                              staticClass: "el-icon-plus avatar-uploader-icon",
                            }),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("el-form-item", { attrs: { label: "", prop: "logo" } }, [
                  _c("div", { staticStyle: { "margin-right": "auto" } }, [
                    _vm._v(
                      "\n            Logo图片可用于处方打印、叫号屏显示，建议白色或透明背景，推荐尺寸720*180\n          "
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        staticStyle: { "margin-right": "auto" },
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.submitForm("ruleForm")
                          },
                        },
                      },
                      [_vm._v("保存")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: { visible: _vm.dialogVisible },
                on: {
                  "update:visible": function ($event) {
                    _vm.dialogVisible = $event
                  },
                },
              },
              [
                _c("img", {
                  attrs: { width: "100%", src: _vm.dialogImageUrl, alt: "" },
                }),
              ]
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }